import ErrorIcon from '@mui/icons-material/Error';

export const ErrorIconMUI = ErrorIcon;
